import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

const DEMO_USER = { id: 0, email: 'demo@glowsalon.com', plan: 'growth', emailVerified: true, createdAt: '2025-06-01T00:00:00Z', region: 'USA', channelAccess: { email: true, sms: true, whatsapp: true } };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [hasBusinessSetup, setHasBusinessSetup] = useState(false);
  const [businessName, setBusinessName] = useState('');
  const [loading, setLoading] = useState(true);
  const [isDemo, setIsDemo] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('demo') === '1') {
      setUser(DEMO_USER);
      setHasBusinessSetup(true);
      setBusinessName('Glow Salon');
      setIsDemo(true);
      setLoading(false);
      return;
    }

    const token = localStorage.getItem('token');
    if (token) {
      api
        .getMe()
        .then((data) => {
          if (data.user && !data.user.emailVerified) {
            return;
          }
          setUser(data.user);
          setHasBusinessSetup(data.hasBusinessSetup);
          setBusinessName(data.businessName || '');
        })
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const data = await api.login({ email, password });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    setHasBusinessSetup(data.hasBusinessSetup);
    setBusinessName(data.businessName || '');
    return data;
  };

  const loginDemo = () => {
    localStorage.setItem('demo', '1');
    setUser(DEMO_USER);
    setHasBusinessSetup(true);
    setBusinessName('Glow Salon');
    setIsDemo(true);
  };

  const signup = async (email, password) => {
    const data = await api.signup({ email, password });
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('demo');
    setUser(null);
    setHasBusinessSetup(false);
    setBusinessName('');
    setIsDemo(false);
  };

  const updateUser = (updated) => setUser((prev) => ({ ...prev, ...updated }));
  const markBusinessSetup = () => setHasBusinessSetup(true);

  return (
    <AuthContext.Provider
      value={{ user, hasBusinessSetup, businessName, setBusinessName, loading, isDemo, login, loginDemo, signup, logout, updateUser, markBusinessSetup }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
